import { createTheme, responsiveFontSizes } from "@mui/material/styles";

export let ireckonuTheme = createTheme({
  palette: {
    primary: {
      main: "#D65737",
      contrastText: "#fff",
    },
    secondary: {
      main: "#B3A293",
      contrastText: "#fff",
    },
    info: {
      main: "#F4F0E7",
      contrastText: "#45382D",
    },
  },
  typography: {
    fontFamily: "Inter",
  },
});

ireckonuTheme = responsiveFontSizes(ireckonuTheme);
